import Column from '@app/store/bulkRequest/form/Column';
import ColumnType from '@app/store/bulkRequest/form/ColumnType';

const requiredColumnTypes: ColumnType[] = [
  'DOCUMENT_TITLE',
  'PARTICIPANT_CONTACT',
  'PARTICIPANT_NAME',
];

const requesterInputColumnTypes: ColumnType[] = ['FIELD_TEXT', 'FIELD_CHECKBOX'];

/**
 * 엑셀 헤더에 컬럼 이름에 (필수) 표시를 위해 작성한 함수입니다.
 */
export default function getExcelColumnTitleText(columnValue: Column) {
  if (requiredColumnTypes.includes(columnValue.type)) {
    return `${columnValue.title}(필수)`;
  }

  // 요청자 입력은 필수, 선택 표시 없음
  if (requesterInputColumnTypes.includes(columnValue.type)) {
    return columnValue.title;
  }

  return `${columnValue.title}(선택)`;
}
